import React from "react";
import { Skeleton } from "../ui/skeleton";

const PackageDetailSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Title Skeleton */}
      <div className="max-w-[668px] mb-2">
        <Skeleton className="h-[38px] w-full bg-gray1 rounded-md lg:h-[36px]" />
        <Skeleton className="h-[38px] w-[80%] bg-gray1 rounded-md lg:h-[36px] mt-4" />
      </div>

      {/* Package Details Skeleton (2x2 Grid) */}
      <div className="grid grid-cols-2 gap-6">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="p-4 border border-gray1 rounded-[16px]">
            <div className="flex w-full">
              {/* Left side skeleton (image placeholder) */}
              <div className="h-[300px] w-[280px] bg-gray1 rounded-[16px]">
                <Skeleton className="h-full w-full bg-gray1" />
              </div>

              {/* Right side skeletons (text placeholders) */}
              <div className="flex flex-col flex-grow ml-5">
                <Skeleton className="h-[35px] w-full bg-gray1" />
                <Skeleton className="h-[35px] w-full bg-gray1 mt-3" />
                <Skeleton className="h-[25px] w-full bg-gray1 mt-3" />
                <Skeleton className="h-[25px] w-full bg-gray1 mt-3" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageDetailSkeleton;
